// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC5BpmbWAlfGGx-0DmLbsRKhhmXREQwiJk",
  authDomain: "porrtfolio-soham.firebaseapp.com",
  databaseURL: "https://porrtfolio-soham-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "porrtfolio-soham",
  messagingSenderId: "1079323278797",
  appId: "1:1079323278797:web:e0b43f48ee1537a5809884",
  measurementId: "G-ESXN189LRD"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();